module.exports = __webpack_public_path__ + "static/media/Onboarding_2_dark.45d84b94.mp4";